var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0,0H13V13H0Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M11.22,11.281a.535.535,0,0,1-.538.532H3.152a.535.535,0,0,1-.538-.532V6.489H1l5.555-5a.542.542,0,0,1,.724,0l5.555,5H11.22Z",
    transform: "translate(-0.417 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.aa62b4cd2979e9c878e24e06a392b316.svg";
export { ForwardRef as ReactComponent };